import { render, staticRenderFns } from "./ProtectNow.vue?vue&type=template&id=29eebdea&"
import script from "./ProtectNow.vue?vue&type=script&lang=ts&"
export * from "./ProtectNow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports